<template>
  <div class="stats">
    <div class="stats__duration">
      <p class="lead">Course Duration</p>
      <p class="data">{{ courseDuration }}</p>
    </div>
    <div class="stats__difficulty">
      <p class="lead">Difficulty Level</p>
      <p class="data">
        <DifficultyComponent
          :difficulty="difficulty || 0"
        ></DifficultyComponent>
      </p>
    </div>
    <div v-if="isAuthenticated" class="stats__files">
      <p class="lead">Course Files</p>
      <div class="stats__files-wrapper">
        <a
          v-for="file in files"
          :key="file.id"
          class="data stats__file"
          :href="
            `https://s3.amazonaws.com/api.ine.com/courses/${courseId}/public/${file.url_filename}`
          "
        >
          <DownloadIcon class="stats__download-icon" />
          {{ file.filename }}
        </a>
      </div>
      <p class="data" v-if="files.length === 0">No files</p>
    </div>
  </div>
</template>

<script>
import DifficultyComponent from '@/components/layout/DifficultyComponent.vue'
import DownloadIcon from '@/assets/icons/course/download.svg'

export default {
  name: 'Stats',
  components: {
    DifficultyComponent,
    DownloadIcon: { ...DownloadIcon, name: 'DownloadIcon' },
  },
  props: {
    courseDuration: {
      type: String,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
    difficulty: {
      type: Number,
      required: false,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    files: {
      type: Array,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.stats {
  .lead {
    margin: 0;
    @include tablet {
      white-space: nowrap;
    }
  }
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: var(--dark-gray);
  padding: 20px 10px 0 10px;
  min-height: 117px;
  width: 100%;
  @include desktop {
    justify-content: flex-start;
    padding: 40px 50px 0 0;
  }
  &__duration {
    margin: 0 25px 0 0;
  }
  &__difficulty {
    margin: 0 25px 0 0;
  }
  &__files {
    max-width: 300px;
  }
  &__files-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__file {
    width: 100%;
    font-size: 12px;
    margin: 5px 0 0 0;

    &:hover {
      color: var(--orange);
    }
  }
  &__download-icon {
    margin: 0 5px -2px 0;
    width: 15px;
    height: 15px;
  }
}
</style>
